import { getAuthUrl } from '../../../constants/ssoConstants';

export const PrivateRoute = () => {
  window.location = getAuthUrl();
};
